import { useState } from 'react';
import { CRMProductsDataRequest } from '@entities/product/api/product-types';
import { DEFAULT_CRM_PRODUCTS_LIST_PARAMETERS } from '@entities/product/config/store-constants';
import { useCrmProductsInfinityListQuery } from '@entities/product/api/product-api';
import { useInfinitySelect } from '@shared/lib/hooks/use-infinity-select/use-infinity-select';

export function useCrmProductsInfinityQuery() {
    const [crmProductsParameters, setCrmProductsParameters] = useState<CRMProductsDataRequest>({
        ...DEFAULT_CRM_PRODUCTS_LIST_PARAMETERS,
        take: 10,
    });

    const { data: crmProductsList, isFetching: isCRMProductsListFetching } =
        useCrmProductsInfinityListQuery(crmProductsParameters);

    return useInfinitySelect({
        listData: crmProductsList,
        labelProperty: (item) => `${item.externalId}: ${item.name}`,
        valueProperty: 'externalId',
        isFetching: isCRMProductsListFetching,
        setListParams: setCrmProductsParameters,
    });
}
